export function getHeaderMeta(pathname: string): {title: string; icon: string} {
  if (pathname === '/vehicle-monitoring') {
    return {
      title: 'Monitoring MAP',
      icon: '/media/icons/duotune/maps/map002.svg',
    }
  }
  if (pathname === '/assign-vehicle-view') {
    return {
      title: 'Available Vehicles',
      icon: '/media/icons/duotune/maps/map003.svg',
    }
  }
  return {
    title: 'View Map',
    icon: '/media/icons/duotune/maps/map001.svg',
  }
}

export function MenuInner() {
  // Title is rendered once in HeaderWrapper (outside Metronic swapper) to avoid duplicates.
  return null
}
